import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectCatalogBibEntities } from '../EntitiesSelector';

const getCurrentBibId = state => state.getIn(['catalogBibs', 'catalogBib', 'id'], Immutable.Map());

export const selectCatalogBib = createSelector([selectCatalogBibEntities, getCurrentBibId], (catalogBibs, id) =>
  catalogBibs.get(id)
);

export const selectContributorNames = createSelector([selectCatalogBib], catalogBib =>
  catalogBib
    .get('fields', Immutable.List())
    .find(fieldSet => fieldSet.get('category') === 'CONTRIBUTORS', null, Immutable.Map())
    .get('items', Immutable.List())
    .find(fieldSet => fieldSet.get('fieldName') === 'CONTRIBUTOR_NAME', null, null)
);

export const selectContainedWork = createSelector([selectCatalogBib], catalogBib =>
  catalogBib
    .get('fields', Immutable.List())
    .find(fieldSet => fieldSet.get('category') === 'CONTAINS', null, Immutable.Map())
    .get('items', Immutable.List())
    .find(fieldSet => fieldSet.get('fieldName') === 'CONTAINS_WORK', null, Immutable.Map())
    .get('fieldValues', Immutable.List())
);

export const selectSubjectsAndGenres = createSelector([selectCatalogBib], catalogBib => {
  const fieldItems = catalogBib
    .get('fields', Immutable.List())
    .find(fieldSet => fieldSet.get('category') === 'SUBJECTGENRE', null, Immutable.Map())
    .get('items', Immutable.List());

  return fieldItems.flatMap(fieldItem => fieldItem.get('fieldValues', Immutable.List()));
});

export default {
  selectCatalogBib,
  selectContributorNames,
  selectContainedWork,
  selectSubjectsAndGenres
};
